'use strict';
const getCookie = require('./modules/util/getCookie');
const createCookie = require('./modules/util/createCookie');

function getGeolocation() {
    const fastlyGeolocationCookie = getCookie('fastlyGeolocation');
    if (!fastlyGeolocationCookie) {
        $.ajax({
            url: Urls.fastlyGeolocationEndpoint,
        }).done(function (data) {
            if (data && data.country_code) {
                createCookie('fastlyGeolocation', data.country_code, 1);
            } else {
                return;
            }
        });
    }
}

function initializeEvents() {
    getGeolocation();
}

const fastlyGeolocation = {
    init: function() {
        initializeEvents();
    }
};

module.exports = fastlyGeolocation;
